export const SET_INITIAL_DATA = "SET_INITIAL_DATA";

export const REQUEST_JOBS = "REQUEST_JOBS";
export const RECEIVE_JOBS_SUCCESS = "RECEIVE_JOBS_SUCCESS";
export const RECEIVE_JOBS_ERROR = "RECEIVE_JOBS_ERROR";
